import "./UserRegistration.css";
import React, { useEffect, useState, useRef } from "react";
import SearchComponent from "../CreateRole/SearchComponent";
import { fetchRoleData } from "../../Redux/features/CreateRole/createRoleSlice";
import { useSelector, useDispatch } from "react-redux";
import bin from "../../Assets/Images/CreateRole/Trash.png";
import search from "../../Assets/Images/CreateRole/Search.png";
import drop from "../../Assets/Images/CreateBatch/drop.png";
import availableImage from "../../Assets/Images/CreateBatch/drop.png";
import notAvailableImage from "../../Assets/Images/CreateRole/Trash.png";
import leftarrowrole from "../../Assets/Images/CreateBatch/Group27.png";
import rightarrowrole from "../../Assets/Images/CreateBatch/Group27(1).png";
import leftarrow from "./../../Assets/Images/CreateBatch/Group27.png";
import rightarrow from "../../Assets/Images/CreateBatch/Group27(1).png";
import { FULL_API_BASE_URL } from "../../Config/Config";
import Swal from "sweetalert2";
import EmployeeDropdown from "./SearchPagination";
function UserReg(dataClient) {
  const [roles, setRoles] = useState([]);
  const [employeeName, setEmployeeName] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeStaffId, setEmployeeStaffId] = useState("");
  const appAccessDropdownRef = useRef(null);
  const [roleCode, setRoleCode] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  const [employeeType, setEmployeeType] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [managerName, setManagerName] = useState("");
  const dropdownRef = useRef(null);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [checkedRoles, setCheckedRoles] = useState([]);
  const [screens, setScreens] = useState([]);
  const [checkedScreen, setCheckedScreen] = useState(null);
  const [isEditChecked, setIsEditChecked] = useState(false);
  const [status, setStatus] = useState("");
  const [designation, setDesignation] = useState("");
  const [department, setDepartment] = useState("");
  const [Approved, setApproved] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [appAccess, setAppAccess] = useState("");

  const [searchText, setSearchText] = useState("");
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [visibleSections, setVisibleSections] = useState({});
  const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient.dataClient?.client_schema_name[6][0].client_id;
  const [showRoleDropdown, setShowRoleDropdown] = useState(false);
  const [roleCurrentPage, setRoleCurrentPage] = useState(1);
  const [roleItemsPerPage] = useState(6);
  const roleDropdownRef = useRef(null);
  const [showAppAccessDropdown, setShowAppAccessDropdown] = useState(false);
  const [totalRolePages, setTotalRolePages] = useState(1);
  const appAccessOptions = ["Web Portal", "Mobile Application", "Both"];
  const pageNumbers = [];
  for (let i = 1; i <= totalRolePages; i++) {
    pageNumbers.push(i);
  }

  const [dropdownKey, setDropdownKey] = useState(0);

  const handleAppAccessSelect = (option) => {
    setAppAccess(option);
    setShowAppAccessDropdown(false);
    setDropdownKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (
        roleDropdownRef.current &&
        !roleDropdownRef.current.contains(event.target)
      ) {
        setShowRoleDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const { data, loading, error } = useSelector((state) => state.createRole);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRoleData());
  }, [dispatch]);

  useEffect(() => {
    fetch(`${FULL_API_BASE_URL}/get-roles/`)
      .then((response) => response.json())
      .then((data) => {
        setRoles(data);
        setTotalRolePages(Math.ceil(data.length / roleItemsPerPage));
      });
  }, []);

  useEffect(() => {
    if (selectedRole) {
      setSelectedRoles([...selectedRoles, selectedRole]);
      setShowDropdown(false);
    }
  }, [selectedRole]);

  // useEffect(() => {
  //   if (employeeName) {
  //     setIsLoading(true);
  //     fetch(
  //       `${FULL_API_BASE_URL}/get-employee-by-search-key/?search_key=${employeeName}`
  //     )
  //       .then((response) => {
  //         if (!response.ok) {
  //           throw new Error("Network response was not ok");
  //         }
  //         return response.json();
  //       })
  //       .then((data) => {
  //         setEmployeeList(data);
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error(
  //           "There has been a problem with your fetch operation:",
  //           error
  //         );
  //         setIsLoading(false);
  //       });
  //   }
  // }, [employeeName]);

  useEffect(() => {
    if (employeeName) {
      setIsLoading(true);
      fetch(
        `${FULL_API_BASE_URL}/get-employee-by-search-key/?search_key=${employeeName}`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          // Filter employees to show only those with app_user = 1
          const filteredEmployees = data.filter((emp) => emp.app_user === 1);
          setEmployeeList(filteredEmployees);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error
          );
          setIsLoading(false);
        });
    }
  }, [employeeName]);

  // useEffect(() => {
  //   // Only search when user has typed at least 3 characters
  //   if (employeeName && employeeName.length >= 3) {
  //     setIsLoading(true);
  //     fetch(
  //       `${FULL_API_BASE_URL}/get-employee-by-search-key/?search_key=${employeeName}`
  //     )
  //       .then((response) => {
  //         if (!response.ok) {
  //           throw new Error("Network response was not ok");
  //         }
  //         return response.json();
  //       })
  //       .then((data) => {
  //         // ✅ Show all employees without filter
  //         setEmployeeList(data);
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error(
  //           "There has been a problem with your fetch operation:",
  //           error
  //         );
  //         setIsLoading(false);
  //         setEmployeeList([]); // Clear list on error
  //       });
  //   } else {
  //     // Clear employee list if less than 3 characters
  //     setEmployeeList([]);
  //     setIsLoading(false);
  //   }
  // }, [employeeName]);

  useEffect(() => {
    fetch(`${FULL_API_BASE_URL}/get-role-screen-access_all/`)
      .then((response) => response.json())
      .then((data) => setScreens(data));
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  const [username, setUsername] = useState("");
  const [usernameAvailable, setUsernameAvailable] = useState(null);
  const [usernameError, setUsernameError] = useState(""); // <-- NEW

  useEffect(() => {
    if (username) {
      fetch(
        `${FULL_API_BASE_URL}/check-username-availability/?username=${username}`
      )
        .then((response) => response.text())
        .then((data) => setUsernameAvailable(data));
    }
  }, [username]);

  // const handleUsernameChange = (event) => {
  //   setUsername(event.target.value.toLowerCase());
  // };

  const handleUsernameChange = (e) => {
    const raw = e.target.value;
    // allow: lowercase letters, numbers, underscore
    const sanitized = raw.toLowerCase().replace(/[^a-z0-9_]/g, "");
    setUsername(sanitized);

    // only length validation message
    setUsernameError(
      sanitized.length > 0 && sanitized.length < 5 ? "Too Short" : ""
    );
  };

  useEffect(() => {
    if (!username || username.length < 5 || usernameError) {
      setUsernameAvailable(null);
      return;
    }

    const ac = new AbortController();
    const t = setTimeout(async () => {
      try {
        const res = await fetch(
          `${FULL_API_BASE_URL}/check-username-availability/?username=${encodeURIComponent(
            username
          )}`,
          { signal: ac.signal }
        );
        let text = (await res.text()).trim(); // e.g. `"Available"` or `Available`
        text = text.replace(/^"+|"+$/g, ""); // strip surrounding quotes
        setUsernameAvailable(text); // -> Available | Not Available
      } catch (e) {
        if (e.name !== "AbortError") console.error(e);
        setUsernameAvailable(null);
      }
    }, 300);

    return () => {
      ac.abort();
      clearTimeout(t);
    };
  }, [username, usernameError, FULL_API_BASE_URL]);

  const hint = usernameError ? usernameError : usernameAvailable || ""; // "Available" | "Not Available" | ""

  const hintColor = usernameError
    ? "red"
    : !username || username.length < 5
    ? "red"
    : usernameAvailable === "Available"
    ? "green"
    : usernameAvailable
    ? "red"
    : undefined;

  const handleEmployeeNameChange = (event) => {
    setEmployeeName(event.target.value);
    if (event.target.value === "") {
      setEmployeeList([]);
      setShowDropdown(false);
    } else {
      setShowDropdown(true);
    }
  };

  const handleEmployeeSelect = (employee) => {
    let fullName = `${employee.emp_last_name} , ${employee.emp_first_name}`;
    if (employee.emp_middle_name) {
      fullName += ` ${employee.emp_middle_name}`;
    }
    setEmployeeName(fullName);
    setEmployeeId(employee.emp_id || <span>&nbsp;</span>);
    setManagerName(employee.manager_name || <span>&nbsp;</span>);
    setApproved(employee.approved_by || <span>&nbsp;</span>);
    setStatus(employee.status || <span>&nbsp;</span>);
    setDesignation(employee.designation || <span>&nbsp;</span>);
    setDepartment(employee.department || <span>&nbsp;</span>);
    setEmployeeType(employee.emp_type || <span>&nbsp;</span>);
    setShowDropdown(false);
    setEmployeeStaffId(employee.staff_number || <span>&nbsp;</span>);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employeeList.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    if (
      pageNumber < 1 ||
      pageNumber > Math.ceil(employeeList.length / itemsPerPage)
    ) {
      return;
    }
    setCurrentPage(pageNumber);
  };

  const goToFirstPage = () => {
    setCurrentPage(1);
  };

  const goToLastPage = () => {
    setCurrentPage(Math.ceil(employeeList.length / itemsPerPage));
  };

  const handleRemoveSelected = () => {
    setSelectedRoles(
      selectedRoles.filter((role) => !checkedRoles.includes(role.role_id))
    );
    setCheckedRoles([]);
  };

  const handleClick = () => {
    setIsClicked(true);
  };
  const handleSearch = () => {
    const filteredResults = data.filter((item) =>
      item.screen_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setSearchResults(filteredResults);
    setDropdownVisible(true);
  };
  const handleSelectItem = (item) => {
    if (
      !selectedScreens.some((screen) => screen.screen_id === item.screen_id)
    ) {
      setSelectedScreens([...selectedScreens, item]);
    }
    setDropdownVisible(false);
  };
  const handleRoleSelect = (role) => {
    if (
      !selectedRoles.some(
        (existingRole) => existingRole.role_id === role.role_id
      )
    ) {
      setSelectedRoles([...selectedRoles, role]);
    }
    setShowRoleDropdown(false);
  };

  const handleDeleteItem = (screenId) => {
    setSelectedScreens(
      selectedScreens.filter((screen) => screen.screen_id !== screenId)
    );
  };

  const toggleSectionVisibility = (screenId) => {
    setVisibleSections((prevState) => ({
      ...prevState,
      [screenId]: !prevState[screenId],
    }));
  };

  const handleClearUR = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  const handlePermissionChange = (
    screenId,
    secId,
    permissionType,
    isChecked
  ) => {
    const updatedPermissions = {
      ...permissions,
      [screenId]: {
        ...(permissions[screenId] || {}),
        [permissionType]: isChecked,
        sections: {
          ...(permissions[screenId]?.sections || {}),
          [secId]: {
            ...(permissions[screenId]?.sections?.[secId] || {}),
            [permissionType]: isChecked,
          },
        },
      },
    };
    setPermissions(updatedPermissions);
  };

  const getPermissionsData = () => {
    const roleIds = selectedRoles.map((role) => role.role_id);
    let permissionsData = [];

    selectedScreens.forEach((screen) => {
      let screenPermissions = permissions[screen.screen_id] || {};

      let screenData = {
        sections: screen.sections.map((section) => {
          let sectionPermissions =
            (screenPermissions.sections &&
              screenPermissions.sections[section.sec_id]) ||
            {};
          return {
            screen_id: screen.screen_id,
            wb_scr_sec_id: section.sec_id,
            create_perm: screenPermissions.create ? 1 : 0,
            read_perm: screenPermissions.read ? 1 : 0,
            update_perm: sectionPermissions.view ? 1 : 0,
            delete_perm: screenPermissions.delete ? 1 : 0,
            client_id: 1,
            create_date: null,
            created_by: "string",
            last_modified_by: "string",
          };
        }),
      };

      permissionsData.push(...screenData.sections);
    });

    const data = {
      user_screen_list: permissionsData,
      role_id_list: roleIds,
    };

    return data;
  };

  const handleSavePermissions = async () => {
    const permissionsData = getPermissionsData();
    console.log(permissionsData);

    let web_user_flag = 0;
    let app_user_flag = 0;

    if (appAccess === "Web Portal") {
      web_user_flag = 1;
    } else if (appAccess === "Mobile Application") {
      app_user_flag = 1;
    } else if (appAccess === "Both") {
      web_user_flag = 1;
      app_user_flag = 1;
    }
    if (!employeeName) {
      Swal.fire({
        title: "Fill All Input Fields",
        text: "Please check whether all inputs fields are filled",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    } else {
      try {
        const user_name =
          dataClient.dataClient.client_schema_name[6][0].user_name;
        const response = await fetch(
          `${FULL_API_BASE_URL}/new-user?client_id=${clientId}&emp_id=${employeeId}&user_name=${username}&web_user_flag=${web_user_flag}&app_user_flag=${app_user_flag}&created_by_user_name=${user_name}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(permissionsData),
          }
        );

        if (response.ok) {
          Swal.fire({
            title: "User Registered Successfully",
            icon: "success",
            timer: 2000,
            confirmButtonColor: "#318682",
          }).then(() => {
            setTimeout(function () {
              window.location.reload();
            }, 100);
          });
        }

        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }

        const data = await response.json();
      } catch (error) {
        console.error("Error creating data:", error);
      }
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        appAccessDropdownRef.current &&
        !appAccessDropdownRef.current.contains(event.target)
      ) {
        setShowAppAccessDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        roleDropdownRef.current &&
        !roleDropdownRef.current.contains(event.target)
      ) {
        setShowRoleDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const screenDropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        screenDropdownRef.current &&
        !screenDropdownRef.current.contains(event.target)
      ) {
        setDropdownVisible(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div
        style={{
          height: "auto",
          width: "100%",
          paddingLeft: "20px",
          marginBottom: "90px",
          position: "relative",
        }}
      >
        <div className="container-UP" style={{ position: "sticky", top: "0" }}>
          <div className="Header-up ">
            <p className="title-cb ">User Registration Form </p>
            <div className="mb-2-UP grey-color-font">
              <button className="cr-cancel-btn me-cs4" onClick={handleClearUR}>
                CANCEL
              </button>
              <button className="cr-create-btn" onClick={handleSavePermissions}>
                SAVE
              </button>
            </div>
          </div>
          <hr
            style={{
              color: "black",
              backgroundColor: "black",
              marginTop: "5px",
            }}
          />
        </div>

        <div className="container-cs-fluid ms-cs3 mt-cs3">
          <div className="row-v">
            <div className="card-border-shadow-UR UR-form-size">
              <ul className="list-group list-group-flush">
                <div className="header-color-dark border-btm-v ">
                  <p className="ms-4-v border-ttm-v header-user-details-v">
                    USER DETAILS
                  </p>
                </div>

                <li className="list-group-item element-color-light list-group-no-padding">
                  <p className="px-0 mb-0 ms-4-v grey-color-font  border-ttm-v">
                    Select Employee
                  </p>

                  <div ref={dropdownRef}>
                    <EmployeeDropdown
                      employeeName={employeeName}
                      handleEmployeeNameChange={handleEmployeeNameChange}
                      showDropdown={showDropdown}
                      currentItems={currentItems}
                      handleEmployeeSelect={handleEmployeeSelect}
                      currentPage={currentPage}
                      itemsPerPage={itemsPerPage}
                      employeeList={employeeList}
                      paginate={paginate}
                      goToFirstPage={goToFirstPage}
                      goToLastPage={goToLastPage}
                      leftarrow={leftarrow}
                      rightarrow={rightarrow}
                      inputClassName="font-UR smaller-size-2 ms-4-v mt-1-v mb-4-v"
                      dropdownClassName="dropdown-v"
                      dropdownClassName_2="dropdown-item-v"
                      paginationClassName="pagination-cs-3"
                    />
                  </div>
                </li>

                <div className="row-v grey-color-font header-color-dark  border-top-bottom-UR">
                  <div className="col-1-custom-v  ">
                    <div className="mb-3-v">Employee Name:</div>
                    <div className="mb-3-v">Employee ID:</div>
                    <div className="mb-3-v">Employee Type:</div>
                    <div className="">Status:</div>
                  </div>
                  <div className="col-v">
                    <div className="mb-3-v">{employeeName}</div>
                    <div className="mb-3-v">{employeeStaffId}</div>
                    <div className="mb-3-v">{employeeType}</div>
                    <div className="">{status}</div>
                  </div>
                  <div className="col-1-custom-v ">
                    <div className="mb-3-v">Manager Name:</div>
                    <div className="mb-3-v">Designation:</div>
                    <div className="mb-3-v">Department:</div>
                    <div className="">Approved by:</div>
                  </div>
                  <div className="col-v">
                    <div className="mb-3-v">{managerName}</div>
                    <div className="mb-3-v">{designation}</div>
                    <div className="mb-3-v">{department}</div>
                    <div className="">{Approved}</div>
                  </div>
                </div>

                <li className="list-group-item element-color-light px-0 list-group-no-padding">
                  <div className="row-v ">
                    <div className="col-v">
                      <li>
                        <p className="  mt-3-v mb-1-v ms-4-v grey-color-font">
                          User Name <span className="red-star">*</span>
                        </p>
                      </li>

                      <li>
                        {/* <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            value={username}
                            onChange={handleUsernameChange}
                            className="smaller-size ms-4-v grey-color-font font-UR"
                            style={{ padding: "5px", outline: "none" }}
                            maxLength={10}
                          />
                          {username && username.length < 5 ? (
                            <div
                              style={{
                                color: "red",
                                position: "absolute",
                                right: "13%",
                                top: "50%",
                                transform: "translateY(-50%)",
                              }}
                            >
                              Too Short
                            </div>
                          ) : usernameAvailable === `"Available"` ? (
                            <div
                              style={{
                                color: "green",
                                position: "absolute",
                                right: "13%",
                                top: "50%",
                                transform: "translateY(-50%)",
                              }}
                            >
                              {usernameAvailable}
                            </div>
                          ) : (
                            <div
                              style={{
                                color: "red",
                                position: "absolute",
                                right: "13%",
                                top: "50%",
                                transform: "translateY(-50%)",
                              }}
                            >
                              {usernameAvailable}
                            </div>
                          )}
                        </div> */}

                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            value={username}
                            onChange={handleUsernameChange}
                            className="smaller-size ms-4-v grey-color-font font-UR"
                            style={{ padding: "5px", outline: "none" }}
                            maxLength={10}
                            autoComplete="off"
                            spellCheck="false"
                          />
                          <div
                            style={{
                              position: "absolute",
                              right: "13%",
                              top: "50%",
                              transform: "translateY(-50%)",
                              whiteSpace: "nowrap",
                              fontWeight: 500,
                              color: hintColor,
                            }}
                          >
                            {hint}
                          </div>
                        </div>
                      </li>

                      <li>
                        <p className="  mt-3-v mb-1-v ms-4-v grey-color-font">
                          Add Role
                        </p>
                      </li>
                      <li>
                        <div
                          className="add-role-div"
                          onClick={() => setShowRoleDropdown(!showRoleDropdown)}
                        >
                          {selectedRole ? selectedRole.role_name : ""}
                          <img
                            src={drop}
                            alt="description"
                            className="drop-role-img"
                          />
                        </div>
                        {showRoleDropdown && (
                          <div
                            className="UR-role-dropdown"
                            ref={roleDropdownRef} // Attach the ref to the dropdown
                          >
                            {roles
                              .slice(
                                (roleCurrentPage - 1) * roleItemsPerPage,
                                roleCurrentPage * roleItemsPerPage
                              )
                              .map((role, index) => (
                                <div
                                  key={index}
                                  onClick={() => {
                                    handleRoleSelect(role);
                                    setShowRoleDropdown(false);
                                  }}
                                  className={`dropdown-item-role ${
                                    index % 2 === 0
                                      ? ""
                                      : " element-color-light"
                                  }`}
                                >
                                  {role.role_name}
                                </div>
                              ))}
                            <div className="pagination-role mt-cs2 mb-cs2 me-cs2">
                              <button onClick={() => setRoleCurrentPage(1)}>
                                <img
                                  src={leftarrowrole}
                                  alt="description"
                                  style={{ width: "40%", height: "40%" }}
                                />
                              </button>
                              <button
                                onClick={() => {
                                  if (roleCurrentPage > 1) {
                                    setRoleCurrentPage(roleCurrentPage - 1);
                                  }
                                }}
                              >
                                {"<"}
                              </button>
                              {roleCurrentPage > 1 && (
                                <button
                                  onClick={() =>
                                    setRoleCurrentPage(roleCurrentPage - 1)
                                  }
                                >
                                  {roleCurrentPage - 1}
                                </button>
                              )}
                              <button className="active-role-page">
                                {roleCurrentPage}
                              </button>
                              {roleCurrentPage < totalRolePages && (
                                <button
                                  onClick={() =>
                                    setRoleCurrentPage(roleCurrentPage + 1)
                                  }
                                >
                                  {roleCurrentPage + 1}
                                </button>
                              )}
                              <button
                                onClick={() => {
                                  if (roleCurrentPage < totalRolePages) {
                                    setRoleCurrentPage(roleCurrentPage + 1);
                                  }
                                }}
                              >
                                {">"}
                              </button>
                              <button
                                onClick={() =>
                                  setRoleCurrentPage(totalRolePages)
                                }
                              >
                                <img
                                  src={rightarrowrole}
                                  alt="description"
                                  style={{ width: "40%", height: "40%" }}
                                />
                              </button>
                            </div>
                          </div>
                        )}
                      </li>
                    </div>

                    <div className="col-v">
                      <p className="mt-3-v mb-1-v grey-color-font ">
                        Application Access
                      </p>

                      <div
                        className="app-access-div"
                        onClick={() =>
                          setShowAppAccessDropdown(!showAppAccessDropdown)
                        }
                      >
                        <img
                          src={drop}
                          alt="description"
                          className="drop-role-img"
                        />
                        <div className="trans-access-name">
                          {appAccess || ""}
                        </div>
                      </div>
                      {showAppAccessDropdown && (
                        <div
                          className="app-access-dropdown"
                          ref={appAccessDropdownRef} // Attach the ref to the dropdown
                        >
                          {appAccessOptions.map((option, index) => (
                            <React.Fragment key={index}>
                              <div
                                className="trans-access-option " // Add this class to each option
                                onClick={() => handleAppAccessSelect(option)}
                              >
                                {option}
                              </div>
                              {index < appAccessOptions.length - 1 && <hr />}{" "}
                              {/* Don't add a line after the last item */}
                            </React.Fragment>
                          ))}
                        </div>
                      )}

                      <button
                        type="button"
                        className="remove-button-UR grey-color-font"
                        onClick={handleRemoveSelected}
                      >
                        Remove Selected
                      </button>
                    </div>

                    <div className="col-3-v grey-color-font">
                      <li>
                        <p className="mt-3-v mb-1-v">User Status</p>
                      </li>
                      <li>
                        <label
                          className={`switch user-status ${
                            isClicked ? "no-border" : ""
                          }`}
                        >
                          <input type="checkbox" checked={true} disabled />
                          <span className="slider round "></span>
                        </label>
                      </li>

                      <div className="user-status">
                        <p className=""></p>
                      </div>
                      <div></div>
                    </div>
                  </div>

                  <div className="grid-container-v">
                    <div className="grid-item-v flex-v-adjust">
                      <span className="ms-5-v grey-color-font">Name</span>
                      <span className="triangle-down"></span>
                    </div>

                    <div className="grid-item-v grey-color-font">Role ID</div>
                    <div className="grid-item-v grey-color-font">
                      Description
                    </div>

                    <hr className="line-UR" />
                    {selectedRoles.map((role, index) => (
                      <React.Fragment key={index}>
                        <div className="grid-item-v table-white-bg">
                          <input
                            type="checkbox"
                            className="ms-3-v"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setCheckedRoles([
                                  ...checkedRoles,
                                  role.role_id,
                                ]);
                              } else {
                                setCheckedRoles(
                                  checkedRoles.filter(
                                    (id) => id !== role.role_id
                                  )
                                );
                              }
                            }}
                          />
                          <span className="ms-3-v grey-color-font">
                            {role.role_name}
                          </span>
                        </div>
                        <div className="grid-item-v table-white-bg grey-color-font">
                          {/* {role.role_id} */}
                          {role.role_code}
                        </div>
                        <div className="grid-item-v table-white-bg grey-color-font">
                          {role.role_desc}
                        </div>
                        <hr className="line-UR" />
                      </React.Fragment>
                    ))}
                  </div>
                </li>

                {/* gaurab ka code */}
              </ul>
              <div style={{ marginTop: "20px", backgroundColor: "#EFEFEF" }}>
                {/* Search component */}
                <div className="transparent-margin-ttm transparent-margin-btm">
                  <div
                    style={{
                      marginLeft: "16px",
                      marginBottom: "5px",
                      marginTop: "5px",
                    }}
                  >
                    Add Screen
                  </div>
                  <div
                    className="cr-screen-search-container ms-cs3 "
                    style={{ width: "31.9%" }}
                  >
                    <input
                      type="text"
                      placeholder="Type here to search"
                      value={searchText}
                      style={{ height: "30px" }}
                      onChange={(e) =>
                        // setSearchText(e.target.value)
                        {
                          const currentSearchText = e.target.value;
                          setSearchText(currentSearchText); // Update searchText state

                          if (currentSearchText.trim() === "") {
                            setDropdownVisible(false);
                            setSearchResults([]);
                          } else {
                            const filteredResults = data.filter((item) =>
                              item.screen_name
                                .toLowerCase()
                                .includes(currentSearchText.toLowerCase())
                            );
                            setSearchResults(filteredResults);

                            setDropdownVisible(filteredResults.length > 0);
                          }
                        }
                      }
                      // onFocus={() => setDropdownVisible(true)}
                      className="transparent-margin-left-UR "
                    />
                    <button
                      className="cr-add-screen-button"
                      onClick={handleSearch}
                    >
                      <img
                        src={drop}
                        alt="search icon"
                        style={{
                          width: "49%",
                          height: "70%",
                          marginTop: "1px",
                          marginLeft: "40%",
                        }}
                      />
                    </button>
                  </div>
                  {dropdownVisible && (
                    <ul
                      className="cr-screen-dropdown-UR ms-cs3"
                      ref={screenDropdownRef} // Attach the ref to the dropdown
                    >
                      {searchResults.map((item) => (
                        <li
                          key={item.screen_id}
                          onClick={() => handleSelectItem(item)}
                        >
                          {item.screen_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div>
                  {selectedScreens.map((screen) => (
                    <div key={screen.screen_id} className="screen-selected-UR">
                      <div className="cr-screen-header-UR screen-selected-UR-2 mt-cs2">
                        <span>{screen.screen_name}</span>
                        <button
                          onClick={() => handleDeleteItem(screen.screen_id)}
                        >
                          {/* Delete */}
                          <img src={bin} alt="" />
                        </button>
                      </div>

                      <div className="cr-permissions cr-screen-header screen-selected-UR">
                        <div className="cr-crud-permissions">
                          <button
                            onClick={() =>
                              toggleSectionVisibility(screen.screen_id)
                            }
                          >
                            {visibleSections[screen.screen_id] ? "-" : "+"}
                          </button>
                          Edit
                          <label className="cr-display-flex">
                            <input
                              type="checkbox"
                              className="cr-custom-checkbox"
                              checked={
                                permissions[screen.screen_id]?.create || false
                              }
                              onChange={(e) =>
                                handlePermissionChange(
                                  screen.screen_id,
                                  null, // No specific section ID for screen-level permissions
                                  "create",
                                  e.target.checked
                                )
                              }
                            />
                            Create
                          </label>
                          <label className="cr-display-flex">
                            <input
                              type="checkbox"
                              checked={
                                permissions[screen.screen_id]?.read || false
                              }
                              className="cr-custom-checkbox"
                              onChange={(e) =>
                                handlePermissionChange(
                                  screen.screen_id,
                                  null, // No specific section ID for screen-level permissions
                                  "read",
                                  e.target.checked
                                )
                              }
                            />
                            Read
                          </label>
                          <label className="cr-display-flex">
                            <input
                              type="checkbox"
                              checked={
                                permissions[screen.screen_id]?.delete || false
                              }
                              className="cr-custom-checkbox"
                              onChange={(e) =>
                                handlePermissionChange(
                                  screen.screen_id,
                                  null, // No specific section ID for screen-level permissions
                                  "delete",
                                  e.target.checked
                                )
                              }
                            />
                            Delete
                          </label>
                        </div>
                      </div>

                      {visibleSections[screen.screen_id] && (
                        <div className="cr-screen-sections-UR">
                          <p style={{ marginBottom: "20px" }}>
                            Select the sections that can be edited by the role
                          </p>
                          {screen.sections.map((section) => (
                            <div key={section.sec_id} className="cr-section">
                              <label className="cr-display-flex">
                                <input
                                  type="checkbox"
                                  className="cr-custom-checkbox"
                                  checked={
                                    permissions[screen.screen_id]?.sections?.[
                                      section.sec_id
                                    ]?.view || false
                                  }
                                  onChange={(e) =>
                                    handlePermissionChange(
                                      screen.screen_id,
                                      section.sec_id,
                                      "view",
                                      e.target.checked
                                    )
                                  }
                                />
                                <span
                                  style={{
                                    marginLeft: "20px",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {section.sec_name}
                                </span>
                              </label>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="float-right-cs PBDI-CB">Powered By DSE Infotech</div> */}
      </div>
    </>
  );
}

export default UserReg;
